import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { ApiError } from './api/ApiError';
import { shellKeys } from './api/hooks/shell';

/**
 * Cliente do react-query.
 *
 * Política de retry: escrita **nunca** repete (Artigo II — a ordem já pode ter
 * saído). Leitura repete uma vez só quando o middleware não respondeu
 * (`middleware_sem_resposta`), como o contrato permite.
 */
/**
 * Códigos de **transporte** até o executor (FR-013, T142): qualquer um deles,
 * em leitura ou escrita, significa que o chip da topbar está desatualizado —
 * "alcançável" virou "fora" — e o `getShell` é invalidado para a transição
 * aparecer sem esperar o `staleTime`.
 */
export const TRANSPORT_CODES = new Set([
  'middleware_fora',
  'middleware_sem_resposta',
  'borda_recusou',
]);

function transportIsFailure(error: unknown): boolean {
  return error instanceof ApiError && TRANSPORT_CODES.has(error.code);
}

export function createQueryClient(): QueryClient {
  const client: QueryClient = new QueryClient({
    queryCache: new QueryCache({
      onError: (error) => {
        if (transportIsFailure(error)) void client.invalidateQueries({ queryKey: shellKeys.shell });
      },
    }),
    mutationCache: new MutationCache({
      onError: (error) => {
        if (transportIsFailure(error)) void client.invalidateQueries({ queryKey: shellKeys.shell });
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (failureCount >= 1) return false;
          return error instanceof ApiError && error.code === 'middleware_sem_resposta';
        },
      },
      mutations: { retry: false },
    },
  });
  return client;
}
